export default __webpack_public_path__ + "static/media/past_photo_01.1727eafb.png";